<template>
  <div class="row flex-grow-1">
    <div class="col-sm-6 col-lg-3">
      <BQdtCard
        name="complaintsRatingsRBTop"
        with-fullscreen
      />
    </div>
    <div class="col-sm-8 col-lg-6">
      <div class="row h-100">
        <div class="col-12 flex-grow-1">
          <BQdtCard
            name="complaintsRatingsRBButton"
            type="button"
          />
          <BQdtCard
            name="complaintsRatingsRBTable"
            type="table"
            with-fullscreen
          />
        </div>
        <div class="col-12 flex-grow-1">
          <BQdtCard
            name="complaintsRatingsRWButton"
            type="button"
          />
          <BQdtCard
            name="complaintsRatingsRWTable"
            type="table"
            with-fullscreen
          />
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-3">
      <BQdtCard
        name="complaintsRatingsRWTop"
        with-fullscreen
      />
    </div>
  </div>
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'Ratings',

  components: { BQdtCard },
}
</script>
